import * as React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

const useAuth = () => {
    // return !!localStorage.getItem('authToken');
    return true;
};

const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({
    children,
}) => {
    const isAuthenticated = useAuth();
    const location = useLocation();

    if (!isAuthenticated) {
        return <Navigate to="/" state={{ from: location }} replace />;
    }

    return <>{children}</>;
};

export default ProtectedRoute;
